import { log } from "../../../commonfunctions/logger";
import { OrderUploadItemDetailsResponse } from "../../../interfaces/interfaces";

const fetchItemDetails = async (
  csv: { sku: any; quantity: any; reference: any },
  index: number,
): Promise<OrderUploadItemDetailsResponse | false> => {
  const url = `${process.env.REACT_APP_HONEYBEE_ROOT_API}/bulk_orders/load_items_detail/`;

  const data = new FormData();
  data.append("index", index.toString());
  data.append("jwt", localStorage.getItem("jwt") ?? "");
  data.append("branch", localStorage.getItem("branch") ?? "");
  data.append("customer_id", localStorage.getItem("customer_id") ?? "");
  data.append("accpac_code", localStorage.getItem("company_accpac_no") ?? "");
  data.append("sku", [csv][0].sku.trim());
  data.append("quantity", [csv][0].quantity);
  data.append("reference", [csv][0].reference);

  const requestConfig = {
    method: "POST",
    body: data,
  };

  try {
    const res = await fetch(url, requestConfig);

    if (res.status === 200) {
      const returnData: OrderUploadItemDetailsResponse = await res.json();
      return returnData;
    } else {
      const error = await res.text();
      throw error;
    }
  } catch (error: any) {
    log(error, "Order upload failed at item fetch");
    return false;
  }
};

export default fetchItemDetails;
